// Don't need anything atm, may need in the future
const convertHtmlToFroalaWithEventInlineAttachments = (html: string): string =>
  html;

export default convertHtmlToFroalaWithEventInlineAttachments;
